export default __webpack_public_path__ + "static/media/todolist.ad7d294e.jpg";